import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { WebcamModule } from 'ngx-webcam';
import { NgxMaskModule } from 'ngx-mask';

import { SharedModule } from '../../../../shared/shared.module';
import { BeforeSelfieComponent } from './before-selfie/before-selfie.component';
import { BemVindoComponent } from './bem-vindo/bem-vindo.component';
import { ModalAvisoIosComponent } from './bem-vindo/modal-aviso-ios/modal-aviso-ios.component';
import { DoneComponent } from './done/done.component';
import { ExpiredLinkComponent } from './expired-link/expired-link.component';
import { ModalTermosComponent } from './termos/modal-termos/modal-termos.component';
import { TermosComponent } from './termos/termos.component';
import { ModalAvisoCpfInvalidoComponent } from './verificacao-seguranca-identificacao/modal-aviso-cpf-invalido/modal-aviso-cpf-invalido.component';
import { VerificacaoSegurancaIdentificacaoComponent } from './verificacao-seguranca-identificacao/verificacao-seguranca-identificacao.component';
import { VerificacaoSegurancaUnicoComponent } from './verificacao-seguranca-unico.component';

@NgModule({
  declarations: [
    VerificacaoSegurancaUnicoComponent,
    BemVindoComponent,
    TermosComponent,
    ModalTermosComponent,
    BeforeSelfieComponent,
    VerificacaoSegurancaIdentificacaoComponent,
    ModalAvisoCpfInvalidoComponent,
    ModalAvisoIosComponent,
    DoneComponent,
    ExpiredLinkComponent,
  ],
  imports: [
    FormsModule,
    CommonModule,
    SharedModule,
    ReactiveFormsModule,
    WebcamModule,
    NgxMaskModule.forRoot()
  ],
  entryComponents: [
    ModalTermosComponent,
    ModalAvisoCpfInvalidoComponent,
    ModalAvisoIosComponent
  ],
  exports: [VerificacaoSegurancaUnicoComponent],
  providers: []
})
export class VerificacaoSegurancaUnicoModule { }
